if (!customElements.get("new-slider-review-v2")) {
  class reviewsSliderV2 extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.slider = this.querySelector(".new-slider-review-v2__slider");
      this.nextBtn = this.querySelector(".new-slider-review-v2__next-btn");
      this.prevBtn = this.querySelector(".new-slider-review-v2__prev-btn");
      this.initSlider();
    }

    initSlider() {
      if(!this.slider) return;

      const autoplayDelay = parseInt(this.slider.dataset.autoplayDelay);
      
      const swiperOptions = {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        grabCursor: true,
        effect: "fade",
        navigation: {
          nextEl: this.nextBtn,
          prevEl: this.prevBtn,
        },
      };

      if (autoplayDelay && autoplayDelay > 0) {
        swiperOptions.autoplay = {
          delay: autoplayDelay * 1000,
          disableOnInteraction: false,
        };
      }

      const swiper = new Swiper(this.slider, swiperOptions);
    }
  }

  customElements.define("new-slider-review-v2", reviewsSliderV2);
}
